import { lazy } from "react";

import pathRoutes from "routes/pathRoutes";

const MainPage = lazy(() => import("./Pages/Main"));

export const regulationsRoutes = [
  {
    page: MainPage,
    path: pathRoutes.regulations,
  },
];
